<template>
  <div id="duplicate-input">
    <h4 class="sub-title">Duplicate</h4>
    <div class="activeInput mt-4">
      <b-form-checkbox
        v-model="duplicate"
        name="duplicate"
        value="true"
        unchecked-value="false"
        size="lg"
      >This record is a duplicate</b-form-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: "DuplicateInput",
  props: {
    singular: String,
    plural: String
  },
  computed: {
    duplicate: {
      get() {
        console.log(
          "duplicate: ",
          this.$store.state[this.plural][this.singular].user_flagged_duplicate
        );
        return this.$store.state[this.plural][this.singular]
          .user_flagged_duplicate;
      },
      set(val) {
        this.$store.commit(`${this.plural}/user_flagged_duplicate`, val);
      }
    }
  }
};
</script>
